export const INITIAL_LOAD_ACTION = "initialLoadAction";
export const LOGIN_ACTION = "loginAction";
export const RESEND_CODE_ACTION = "resendCodeAction";
export const GRANT_CONSENT_ACTION = "grantConsentAction";
export const DENY_CONSENT_ACTION = "denyConsentAction";
